var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._b({staticClass:"c-boxed-text",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},'svg',_vm.svgAttributesObj,false),[_c('text',{ref:"text",style:(_vm.textStyleObj)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }